import { makeStyles } from "@fluentui/react-components";

export const useLoadingStyles = makeStyles({
  container: {
    display: "flex",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    justifyContent: "center",
    alignContent: "center",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "36px",
    minHeight: "100vh",
    minWidth: "100vw",
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
  },
  vBouncing: {
    height: "128px",
    width: "128px",
    animationName: [
      {
        from: { transform: "translateY(0)" },
        to: { transform: "translateY(30px)" },
      },
    ],
    animationDuration: "0.5s",
    animationDirection: "alternate",
    animationIterationCount: "infinite",
  },
});
